module.exports = __webpack_public_path__ + "static/media/heart_outline.cd4d03db.svg";